import { loadUser } from 'reactApp/modules/user/user.thunkActions';
import { WorkspaceSuperAppService } from 'reactApp/services';
import { store } from 'reactApp/store';

export const initSuperApp = async () => {
    const { isError, isEnabled } = await WorkspaceSuperAppService.init();

    if (isError) {
        window.ContentLoader?.setJSLoaded?.();
        window.ContentLoader?.setCssLoaded?.();

        return false;
    }

    if (isEnabled) {
        await store.dispatch(loadUser(true));
    }

    return true;
};
